<template>
  <el-container>
    <el-header height="auto">
      <root-header />
    </el-header>
    <router-view :key="$route.fullPath" />
    <root-footer />
  </el-container>
</template>

<script>
// @ is an alias to /src
import rootHeader from '@/components/layout/RootHeader'
import rootFooter from '@/components/layout/RootFooter'

export default {
  components: {
    rootHeader,
    rootFooter
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
html, body {
  margin: 0px;
  font-family: 'Open Sans', "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
p {
  margin: 0;
  padding: 0;
}
.center-aligned {
  text-align: center;
}
.center-margin {
  margin: 0 auto;
}
.right-floated {
  float: right;
}
.container {
  width: 1180px;
  margin: 0 auto;
  padding: 0px 10px;
}
.min-container {
  min-width: 1200px;
}
.inline-block {
  display: inline-block;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-header, .el-footer {
  min-width: 1200px;
  padding: 0px;
  // background-color: #000;
}
.el-header {
  position: fixed;
  // width: 100%;
  left: 0;
  top: 0;
  z-index: 20;
  width: 100%;
  background: #000;
  @media only screen and (max-width: 1200px) {
    position: absolute;
  }
}
</style>
